export const MENU_LINKS: { label: string; path: string }[] = [
  { path: "/", label: "Accueil" },
  { path: "/shop", label: "Boutique" },
  { path: "/about-us", label: "A Propos de Nous" },
  { path: "/contact-us", label: "Contactez-Nous" },
];
